import { IssueCodeError } from '@msc-b2c/interfaces/interfaces';

export const getDiningIssueCode = (error: unknown): string | undefined => {
  if (typeof error === 'object' && error !== null && 'issue_code' in error) {
    const issueCode = (error as IssueCodeError).issue_code;
    if (typeof issueCode === 'string' && issueCode.trim().length > 0) {
      return issueCode;
    }
  }

  return undefined;
};
